import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import FormSection from '../../shared/components/FormSection'
import TextArea from '../../shared/components/TextArea'
import AttributedListInput from '../../shared/components/AttributedListInput'

class ReferenceFormSection extends Component {

  @autobind
  handleLanguageChange({ target: { name, value } }) {
    if (this.props.onChange) {
      value = value
        .map((lang) => window.APP_CONFIG.list_languages[lang.value])
      this.props.onChange({
        target: {
          name,
          value
        }
      })
    }
  }

  render() {
    const {
      validationObj,
      schools,
      curriculums,
      grades,
      subjects,
      languages,
      onChange,
      readOnly,
      show,
      fieldSpecs
    } = this.props

    const schoolList = window.APP_CONFIG.list_school
    const gradeList = window.APP_CONFIG.list_grade
    const subjectList = window.APP_CONFIG.list_subject
    const languageList = window.APP_CONFIG.list_languages

    return (
      <FormSection
        title="2. Bezug zur Schule"
        show={show}
      >

        <AttributedListInput
          name="schools"
          list={schoolList}
          value={schools.toJS ? schools.toJS() : schools}
          onChange={onChange}
          isValid={validationObj.schools}
          hideAttribute
          disabled={readOnly}
          {...fieldSpecs.schools}
        />

        <TextArea
          value={curriculums}
          name="curriculums"
          // helpText="Bitte den Lehrplanbezug mit Komma getrennt auflisten"
          onChange={onChange}
          disabled={readOnly}
          {...fieldSpecs.curriculums}
        />

        <AttributedListInput
          name="grades"
          size={2}
          list={gradeList}
          value={grades.toJS ? grades.toJS() : grades}
          onChange={onChange}
          isValid={validationObj.grades}
          hideAttribute
          disabled={readOnly}
          {...fieldSpecs.grades}
        />

        <AttributedListInput
          name="subjects"
          list={subjectList}
          value={subjects.toJS ? subjects.toJS() : subjects}
          onChange={onChange}
          isValid={validationObj.subjects}
          hideAttribute
          disabled={readOnly}
          {...fieldSpecs.subjects}
        />

        <AttributedListInput
          name="languages"
          size={4}
          list={languageList}
          value={languages.toJS ? languages.toJS() : languages}
          onChange={onChange}
          isValid={validationObj.languages}
          hideAttribute
          // helpText="In welchen Sprachen ist das museumspädagogische Programm verfügbar?"
          disabled={readOnly}
          {...fieldSpecs.languages}
        />

      </FormSection>
    )
  }
}

ReferenceFormSection.propTypes = {
  description: PropTypes.string,
  email: PropTypes.string,
  fax: PropTypes.string,
  phone: PropTypes.string,
  show: PropTypes.bool,
  website: PropTypes.string,
}

export { ReferenceFormSection as default }



// WEBPACK FOOTER //
// ./src/guided-tour/components/02-ReferenceFormSection.js